module.exports = __webpack_public_path__ + "static/img/flow.54e08a73.png";